import { render, staticRenderFns } from "./AamsInspectionRegInfo.vue?vue&type=template&id=6ef2bad0&scoped=true&"
import script from "./AamsInspectionRegInfo.vue?vue&type=script&lang=js&"
export * from "./AamsInspectionRegInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef2bad0",
  null
  
)

export default component.exports